import React from "react";
import BalancePageSection from "../sections/BalancePageSection/Content";
const BalancePage = () => {
  return <BalancePageSection />;
};

export default BalancePage;
